import {
    BorderRadiusMedium,
    ColorNeutralBlack,
    ColorNeutralWhite,
    ColorNordicGrey1
} from 'autogen/design-tokens/tokens';
import { ControlledReactCounterInput } from 'components/react-counterInput/react-counterInput';
import React, { useState } from 'react';
import styled from 'styled-components';

/* #region styles */
const StyledControlledReactCounterInput = styled(ControlledReactCounterInput)`
    background-color: ${ColorNeutralWhite};
    color: ${ColorNeutralBlack};
    border-width: 1px;
    border-style: solid;
    border-color: ${ColorNordicGrey1};
    border-radius: ${BorderRadiusMedium};
`;

/* #endregion */
export default function PagingInput({
    currentPageNumber,
    onBlur,
    numberOfPages
}: {
    currentPageNumber: number;
    onBlur: (page: number) => void;
    numberOfPages: number;
}) {
    const [pagingInputValue, setPagingInputValue] = useState(currentPageNumber);

    return (
        <StyledControlledReactCounterInput
            size="lg"
            value={pagingInputValue}
            adjustCountButtons={false}
            minValue={1}
            maxValue={numberOfPages}
            onValueChange={(value) => setPagingInputValue(value)}
            onBlur={(value) => onBlur(value)}
            onEnter={(value) => onBlur(value)}
            autoFocus
        />
    );
}
